module.exports = __webpack_public_path__ + "static/media/ak_pic.99a50bae.png";